(ns ui.tailwind-theme
  (:require [clojure.string :as string]
            [reagent.core :as r]
            [ui.dom-globals :as dg]))

(def current-theme (r/atom "zapflow"))

(defn dark-theme?
  "True when `theme` is a dark theme, for example \"zapflow_dark\"."
  [theme]
  (string/ends-with? (str theme) "_dark"))

(defn set-theme!
  "Set the theme of the page. A dark theme also sets the class `dark`, because the
   tw2 tokens (src/css/tw2/semantic.css) change to the dark values only under `.dark`."
  [theme]
  (let [html (.querySelector js/document "html")]
    (js/console.log "Set tailwind theme : " theme)
    (reset! current-theme theme)
    (.setAttribute html "data-theme" theme)
    (dg/toggle-class! (dg/document-element) {:class-name "dark"
                                             :on?        (dark-theme? theme)})))
